import FuseScrollbars from '@fuse/core/FuseScrollbars';
import { Grid, Switch, Typography } from '@material-ui/core';
import { CustomCard, Loader, NoDataTableComponent } from 'app/components/atoms';
import { useCustomerDetailService } from 'app/hooks/services';
import { FormatUtils } from 'app/utils';
import { mapLanguageInfo } from 'app/utils/mapper';
import { motion } from 'framer-motion';

// animation variants
const container = { show: { transition: { staggerChildren: 0.1 } } };

/* Address Card Component */
const AddressCard = ({ addresses }) => (
  <>
    <CustomCard icon="bxs-map" title="Adres Bilgileri">
      {addresses ? (
        <FuseScrollbars
          option={{
            suppressScrollX: true,
            minScrollbarLength: 20
          }}
          className="flex flex-col min-h-0 max-h-160 w-full space-y-8 overflow-y-auto overflow-x-hidden">
          {addresses.map(address => (
            <div
              className="flex flex-col p-8 border-gray-300 border rounded-6 break-all space-y-8 shadow "
              key={address.id}>
              <Typography>
                <span className="font-semibold text-14 text-gray-800">Şehir : </span>
                {address.city.name || '-'}
              </Typography>
              <Typography>
                <span className="font-semibold text-14 text-gray-800">İlçe : </span>
                {address.district.name || '-'}
              </Typography>
              <Typography>
                <span className="font-semibold text-14 text-gray-800">Mahalle : </span>
                {address.region.name || '-'}
              </Typography>

              <Typography>
                <span className="font-semibold text-14 text-gray-800">Başlık : </span>
                {address.title || '-'}
              </Typography>
              <Typography>
                <span className="font-semibold text-14 text-gray-800">Açıklama : </span>
                {address.description || '-'}
              </Typography>
            </div>
          ))}
        </FuseScrollbars>
      ) : (
        <NoDataTableComponent />
      )}
    </CustomCard>
  </>
);

const CustomerInfo = ({ service }) => {
  // variables
  const isDataLoading = !service.data && (!service.isInitialized || service.isLoading);
  const isDataExist = !!service.data && !service.isNetworkError && !service.isError;
  const {
    name,
    surname,
    language,
    birthdate,
    telephone,
    email,
    gender,
    last_login,
    sms_notification_enabled,
    email_notification_enabled,
    push_notification_enabled,
    campaign_notification_enabled,
    addresses
  } = isDataExist && service?.data;

  const personalInfos = [
    { id: 1, label: 'Ad Soyad', value: `${name || '-'} ${surname || '-'}` },
    { id: 2, label: 'Telefon Numarası', value: telephone || '-' },
    { id: 3, label: 'E-Posta Adresi', value: email || '-' },
    { id: 4, label: 'Doğum Tarihi', value: FormatUtils.convertDateString(birthdate) || '-' },
    { id: 5, label: 'Cinsiyet', value: gender || '-' }
  ];

  const mobileAccountInfos = [
    { switch: false, id: 6, label: 'Uygulama Dili', value: language || '-' },
    { switch: false, id: 7, label: 'Son Giriş Tarihi', value: last_login || '-' },
    { switch: true, id: 6, label: 'SMS Bildirimi', value: sms_notification_enabled },
    { switch: true, id: 7, label: 'E-Posta Bildirimi', value: email_notification_enabled },
    { switch: true, id: 8, label: 'Push Bildirimi', value: push_notification_enabled },
    { switch: true, id: 9, label: 'Kampanya Bildirimleri', value: campaign_notification_enabled }
  ];

  if (isDataLoading) return <Loader loading={isDataLoading} />;

  return (
    <>
      {isDataExist && (
        <>
          <motion.div variants={container} initial="hidden" animate="show">
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={8} lg={7}>
                {/* Customer Personal Infos */}
                <CustomCard title="Kişisel Bilgiler" icon="bxs-user-rectangle">
                  {personalInfos.map(item => (
                    <div key={item.id}>
                      <Typography className="font-semibold text-16 text-gray-800">
                        {item.label}
                      </Typography>
                      <Typography className="text-14">{item.value}</Typography>
                    </div>
                  ))}
                </CustomCard>

                {/* Address Infos */}
                <AddressCard addresses={addresses} />
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={5}>
                {/* Mobile Account Infos */}
                <CustomCard title="Bildirim Ayarları" icon="bxs-notification">
                  {mobileAccountInfos.map(item => (
                    <div key={item.id} className="flex items-center justify-between">
                      {item.switch ? (
                        <>
                          <Typography className="font-semibold text-16 text-gray-800">
                            {item.label}
                          </Typography>
                          <Switch checked={item.value} />
                        </>
                      ) : (
                        <>
                          <Typography className="font-semibold text-16 text-gray-800">
                            {item.label}
                          </Typography>
                          <Typography className="text-14">{item.value}</Typography>
                        </>
                      )}
                    </div>
                  ))}
                </CustomCard>
              </Grid>
            </Grid>
          </motion.div>
        </>
      )}
    </>
  );
};

export default CustomerInfo;
